export default {
  parseTimestamp (timestamp) {
    return new Date(timestamp * 1000)
  }
}



// WEBPACK FOOTER //
// ./src/services/utils.js